import React from 'react';

function LoadingSpinner({ message = "Loading..." }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-slate-900/60">
      <div className="bg-white dark:bg-slate-800 rounded-lg p-8 flex flex-col items-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-500"></div>
        <span className="mt-4 text-sm text-slate-600 dark:text-slate-400">{message}</span>
      </div>
    </div>
  );
}

export default LoadingSpinner; 